import React, { Fragment, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import Loading from "../../skeleton/loading";
import DefaultTextarea from "../../inputs/defaultTextarea";
import DefaultButton from "../../buttons/defaultButton";
import { useDispatch } from "react-redux";
import { _transformPayload } from "../../../../utils/common";
// Note: _fetchClasses import removed as class functionality is not available for HR management system
import { useNavigate } from "react-router-dom";
import DefaultInput from "../../inputs/defaultInput";
import DefaultDatePicker from "../../inputs/defaultDatePicker";
import { createReminder } from "../../../../services/workspace/reminder.service";
import { dateFormat } from "../../../../utils/helper";
import { changePassword } from "../../../../services/workspace/user.service";

const validationSchema = Yup.object().shape({
  current_password: Yup.string()
    .trim()
    .required("Current Password is required"),
  new_password: Yup.string()
    .trim()
    .required("New Password is required")
    .min(8, "New Password must be at least 8 characters long")
    .notOneOf(
      [Yup.ref("current_password")],
      "New Password cannot be the same as Current Password"
    ),
  confirm_password: Yup.string()
    .trim()
    .required("Confirm Password is required")
    .oneOf(
      [Yup.ref("new_password")],
      "Confirm Password must match New Password"
    ),
});

const ChangePaswordForm = ({ isModal = false, onClose = () => null }) => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    values,
    touched,
    errors,
  } = useFormik({
    initialValues: {
      current_password: "",
      new_password: "",
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      setIsSubmitting(true);
      const payload = _transformPayload(values);
      changePassword(payload)
        .then((response) => {
          toast.success("Password Change successfully!");
          navigate("/");
          onClose();
        })
        .catch((error) => {
          toast.error(
            "Failed to change password!" + " " + error.response.data?.error
          );
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    },
  });

  return (
    <Fragment>
      {loading ? (
        <Loading />
      ) : (
        <div className="flex flex-col w-full gap-4 bg-white rounded-md ">
          <form onSubmit={handleSubmit} className="flex flex-col gap-8">
            <div className="grid grid-cols-1 gap-4">
              <DefaultInput
                label={"Current Password"}
                name="current_password"
                value={values.current_password}
                onChange={handleChange}
                onBlur={handleBlur}
                error={
                  touched.current_password && errors.current_password
                    ? errors.current_password
                    : ""
                }
                required
              />
              <DefaultInput
                label={"New Password"}
                name="new_password"
                value={values.new_password}
                onChange={handleChange}
                onBlur={handleBlur}
                error={
                  touched.new_password && errors.new_password
                    ? errors.new_password
                    : ""
                }
                required
              />
              <DefaultInput
                label={"Confirm Password"}
                name="confirm_password"
                value={values.confirm_password}
                onChange={handleChange}
                onBlur={handleBlur}
                error={
                  touched.confirm_password && errors.confirm_password
                    ? errors.confirm_password
                    : ""
                }
                required
              />
            </div>
            <div className="flex items-center gap-2">
              <DefaultButton
                variant="default"
                name={"Submit"}
                type="submit"
                loading={isSubmitting}
              />
              {isModal ? (
                <DefaultButton
                  variant="secondary"
                  name="Cancel"
                  onClick={onClose}
                />
              ) : null}
            </div>
          </form>
        </div>
      )}
    </Fragment>
  );
};

export default ChangePaswordForm;
